import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { LogGroup, Size, CreateElement, Scale } from "../../../../MyHelpers";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { CanvasSprite } from "../../../Sprite/CanvasSprite";
import { Slide, SlideFactory2Params } from "./Slide";

export class GameTitleSlide extends Slide {
	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext;   
    public override translator: Translator;
    //protected maxFreeGames: number = 0;
    protected SpriteGameTitle: CanvasSprite = null;   
    protected SripiteTimerLeft: IInterval;
    protected TitleSripiteTimer: IInterval;



    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize:Size) {
        super(initData, p , viewSize) ;
        this.viewSize = viewSize;
		this.logGroup = 	 this.p.logGroup.Add("GameTitleSlide");
		this.resid = 		 this.p.resid.Add("GameTitleSlide");
		this.systemContext = this.p.systemContext.CreateSubContext("GameTitleSlide");
        

        this.view = CreateElement("div", {
            classes: ["GameTitleSlide", this.resid.Scope()],
            style: {
                position: "absolute",
                height: Scale.Hpx(476),
                width: Scale.Wpx(964),
            }
        });
    }


    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        resourceManager.Add(new PixiSpriteResource(this.path + "title_sprite2", ResourceIdentifier.Global.Add(this.initData.GameName + "titlegame").Add("GameTitleSlider"), true, this.logGroup.Add("GameTitleSlider"), true));

    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.SpriteGameTitle = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.p.gameName + "titlegame").Add("GameTitleSlider")).sprite, canvasSize: new Size(Scale.W(964) , Scale.H(476))});
        
        this.SpriteGameTitle.View().style.position = "relative";

        this.view.appendChild(this.SpriteGameTitle.View());


        this.TitleSripiteTimer = this.systemContext.TimingContext().CreateInterval("GameTitleSlider", this.nextAnimInterval, () => this.SpriteGameTitle.Start(false));
    }







	public override View(): HTMLElement
	{
        return this.view;
	}
	
	public override Update()
	{
        this.SpriteGameTitle.Update();
	}
	
	public override Start()
	{
        this.TitleSripiteTimer.Start();
    }

	public override Stop()
	{
        this.TitleSripiteTimer.Stop();
        this.SpriteGameTitle.StopAndReset();
    }
}
